<template>
	<div id="recent-activity">
		<div class="activity-header">
			<h3 class="stackng-header">Recent Activity</h3>
			<a href="#" @click.prevent="closeActivityBar" class="close">
				<ion-icon name="ios-close"></ion-icon>
			</a>
		</div>
		<div v-if="authUser" class="activity-body">
			<div class="tabs is-centered">
				<ul>
					<li class="reads active-tab">
						<a @click="switchTabs('reads')">
							Reads
							<!-- <span class="count">{{recentReadsActivity.length}}</span> -->
						</a>
					</li>
					<li class="others">
						<a @click="switchTabs('others')">Others</a>
					</li>
				</ul>
			</div>
			<div class="reads-container" v-show="currentTab === 'reads'">
				<no-content
					v-if="recentReadsActivity.length < 1"
					:header="noReadsContentHeader"
					:paragraph="noReadsContentParagraph"
				></no-content>
				<activtiy-list-item v-for="story of recentReadsActivity" :story="story" :key="story.url"></activtiy-list-item>
			</div>
			<div class="others-container" v-show="currentTab === 'others'">
				<no-content
					v-if="!recentOthersActivity.length"
					:header="noOthersContentHeader"
					:paragraph="noOthersContentParagraph"
				></no-content>
				<activtiy-list-item v-for="story of recentOthersActivity" :story="story" :key="story.url"></activtiy-list-item>
			</div>
		</div>
		<no-content v-else :header="noAuthuserContentHeader" :paragraph="noAuthuserContentParagraph"></no-content>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { Fragment } from "vue-fragment";
import ActivtiyListItem from "./RecentActivityListItem.vue";
import NoContent from "../errors/NoContent.vue";

export default {
	data() {
		return {
			currentTab: "reads",
			noAuthuserContentHeader: "No activities to show",
			noAuthuserContentParagraph:
				"Create an account or sign in to view activities.",
			noReadsContentHeader: "No recent stories read",
			noReadsContentParagraph:
				"Click on a story story and come back to view your history.",
			noOthersContentHeader: "No other actvities",
			noOthersContentParagraph:
				"You follows and group activities will be shown here."
		};
	},
	components: {
		ActivtiyListItem,
		NoContent,
		Fragment
	},
	computed: {
		...mapGetters({
			authUser: "getAuthUser",
			recentReadsActivity: "getRecentReadsActivity",
			recentOthersActivity: "getRecentOthersActivity"
		})
	},
	methods: {
		closeActivityBar() {
			this.$store.state.app.app.activityBarOpen = false;
		},
		switchTabs(tabName) {
			this.currentTab = tabName;

			document.querySelector(".active-tab").classList.remove("active-tab");
			// document.querySelector(`.${this.currentTab}`).classList.add('active-tab')

			switch (this.currentTab) {
				case "reads":
					document
						.querySelector(`.${this.currentTab}`)
						.classList.add("active-tab");
					break;
				case "others":
					document
						.querySelector(`.${this.currentTab}`)
						.classList.add("active-tab");
					break;
			}
		}
	}
};
</script>

<style scoped>
#recent-activity {
	font-family: "Avenir", "Nunito", sans-serif;
	position: fixed;
	right: 0;
	top: 0;
	height: 100vh;
	min-height: 100vh;
	overflow: scroll;
	width: 400px;
	background-color: #101010;
	z-index: 20;
	padding-top: 0px;
	transition: all 0.5s ease-in-out;
	box-shadow: 7px 0px 40px -8px rgba(0, 0, 0, 0.75);
}

.activity-header {
	background-color: #101010;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	position: sticky;
	position: -webkit-sticky;
	top: 0;
	z-index: 100;
}

.activity-header h3 {
	color: #fff;
}

.close ion-icon {
	font-size: 40px;
	color: #51c715;
}

.tabs {
	margin-bottom: 0;
	position: sticky;
	top: 87px;
	background-color: #101010;
	z-index: 100;
}

.tabs ul {
	border-bottom: none;
}

.tabs li {
	width: 50%;
	border-bottom: 1px solid #000;
}

.tabs li.active-tab a,
.tabs li.active-tab a:hover {
	color: #51c715;
	border-bottom: 1px solid #51c715 !important;
}

.tabs li a {
	border-bottom: 1px solid #000;
	display: block;
	text-align: center;
	font-size: 13px;
	font-weight: 700;
	transition: 0.3s ease all;
	color: #fff;
}

.tabs li a:hover {
	color: #fff;
	border-bottom-color: #1e4609;
}

@media only screen and (max-width: 540px) {
	#recent-activity {
		width: 95%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/recent-activity/RecentActivity.vue